import styled from "styled-components"
import { media } from "../../../styles"

export const Section = styled.header`
  margin: 10rem auto;
`
export const Container = styled.div`
  padding: 10rem 25%;

  display: flex;
  flex-direction: column;

  ${media.tabland`
  padding: 10rem 15%;
  `}

  ${media.phone`
  padding: 5rem 15%;
  `}

  ${media.phonesmall`
  padding: 5rem 5%;

  & img{
   display: none;  
  }
  `}
`

export const Heading = styled.h1`
  font-size: var(--font-size-headingXL);
  font-family: var(--font-heading);

  margin-bottom: 3rem;

  ${media.phonesmall`
  font-size: var(--font-size-headingM);
  `}
`
export const Body = styled.p`
  font-size: var(--font-size-subheadingL);
  font-family: var(--font-body);
  margin-left: 1rem;

  margin-bottom: 7.5rem;

  ${media.phone`
  margin-bottom: 5rem;

  `}

  ${media.phonesmall`
  font-size: var(--font-size-subheading);
  `}
`
